import React, { useEffect } from "react";
import { Snackbar, Backdrop, CircularProgress } from "../../ui";
import { NotificationContainer, NotificationManager } from "react-notifications";
import { useDispatch, useSelector } from "react-redux";
import {
  hideSnackbar,
  hideDialog,
  hideLoader
} from "../../../store/snpGlobalUISlice";
import ConfirmDialog from "../ConfirmDialog";
import { useSnpUI } from "./SnpUiProvider";

const GlobalUIManager = () => {
  const dispatch = useDispatch();

  const {
    snackbar,
    loaderVisible,
    dialog,
    notification
  } = useSelector((state) => state.snpGlobalUi);

  const { dialog: dialogActions } = useSnpUI();

  // Handle Snackbar close
  const handleSnackbarClose = (_, reason) => {
    if (reason === "clickaway") return;
    dispatch(hideSnackbar());
  };

  // Handle Dialog actions
  const handleDialogClose = () => dispatch(hideDialog());

  const handleDialogConfirm = () => {
    const cb = dialogActions.getCallbacks().onConfirm;
    if (typeof cb === "function") cb();
    dialogActions.hide();
  };
  
  const handleDialogCancel = () => {
    const cb = dialogActions.getCallbacks().onCancel;
    if (typeof cb === "function") cb();
    dialogActions.hide();
  };
  // Fire off notification manager if title changes
  useEffect(() => {
    if (notification?.title) {
      const contentUi = (
        <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
          {notification.body}
        </p>
      );
      const type = notification.type || 1;
      const timeout = notification.timeout || 2000;

      switch (type) {
        case 2:
          NotificationManager.warning(notification.title, contentUi, timeout, notification.callback);
          break;
        case 3:
          NotificationManager.error(notification.title, contentUi, timeout, notification.callback);
          break;
        default:
          NotificationManager.info(notification.title, contentUi, timeout, notification.callback);
          break;
      }
    }
  }, [notification]);

  return (
    <>
      {/* Loader */}
      <Backdrop open={loaderVisible} style={{ zIndex: 1301 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        message={snackbar.message}
        onClose={handleSnackbarClose}
        anchorOrigin={{
          vertical: snackbar.vertical || "bottom",
          horizontal: snackbar.horizontal || "left",
        }}
        sx={{
          "& .UiSnackbarContent-root": {
            backgroundColor: snackbar.color || "black",
            color: "#fff",
            maxWidth: "80vw",
            whiteSpace: "pre-wrap",
          },
          "& .UiSnackbarContent-message": {
            width: "100%",
            wordBreak: "break-word",
          },
        }}
      />

      {/* Dialog */}
      <ConfirmDialog
        isOpen={dialog.open}
        title={dialog.title}
        subTitle={dialog.subTitle}
        negativeReq={dialog.negativeReq}
        negativeAction={dialog.negativeAction}
        positiveReq={dialog.positiveReq}
        positiveAction={dialog.positiveAction}
        onClose={handleDialogClose}
        outSideClickDismiss = {dialog.outSideClickDismiss}
        iconReq={dialog.iconReq}
        iconContent={dialog.iconContent}
        onSubmit={handleDialogConfirm}
        cancelExtra={dialog.cancelExtra}
        onCancel={handleDialogCancel}
        gui={dialog.gui}
      />

      {/* Notification Container */}
      <NotificationContainer />
    </>
  );
};

export default GlobalUIManager;
